/**
 * What the shell remembers in the browser, by name — one place, so the
 * script that applies a choice before paint and the control that saves it
 * cannot drift apart (a typo on either side saves a choice that is never
 * applied, and nothing would go red).
 */
export const KEYS = {
  theme: "prospect-theme",
  nav: "prospect-nav",
  dock: "prospect-chat-dock",
  dockWidth: "prospect-chat-dock-w",
  floatHeight: "prospect-chat-float-h",
} as const;

/**
 * Runs before anything paints (next/script beforeInteractive in
 * app/layout.tsx): the theme from the saved choice, else the system's; the
 * rail's fold from the saved choice. Reading these after React mounts shows
 * one frame of the wrong palette on every load.
 */
export const PREPAINT =
  "try{var h=document.documentElement,t=localStorage.getItem('" + KEYS.theme + "');" +
  "if(!t&&window.matchMedia)t=matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light';" +
  "h.setAttribute('data-theme',t==='dark'?'dark':'light');" +
  "h.setAttribute('data-nav',localStorage.getItem('" + KEYS.nav + "')==='closed'?'closed':'open')}catch(e){}";
